import { OverheadCuttingMaterialCode } from "../constants";

export const isCuttingMaterial = (structureCode: string) =>
    structureCode === OverheadCuttingMaterialCode;
